var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import uniqueId from 'lodash/uniqueId';

import './DatalistItem.scss';

var DatalistItem = function (_React$Component) {
    _inherits(DatalistItem, _React$Component);

    function DatalistItem(props) {
        _classCallCheck(this, DatalistItem);

        var _this = _possibleConstructorReturn(this, (DatalistItem.__proto__ || Object.getPrototypeOf(DatalistItem)).call(this, props));

        _this.setActiveItemID = function () {
            var setActiveItemID = _this.props.setActiveItemID;

            if (setActiveItemID) {
                setActiveItemID(_this.id);
            }
        };

        _this.id = uniqueId('datalistitem');
        return _this;
    }

    _createClass(DatalistItem, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.isActive) {
                this.setActiveItemID();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isActive && !this.props.isActive) {
                this.setActiveItemID();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                isActive = _props.isActive,
                rest = _objectWithoutProperties(_props, ['children', 'className', 'isActive']);

            var classes = classNames('datalist-item', { 'is-active': isActive }, className);
            var itemProps = omit(rest, ['closeDropdown', 'setActiveItemID']);

            // required aria props are added dynamically
            /* eslint-disable jsx-a11y/role-has-required-aria-props */
            return React.createElement(
                'li',
                _extends({}, itemProps, { className: classes, id: this.id, role: 'option' }),
                children
            );
            /* eslint-enable jsx-a11y/role-has-required-aria-props */
        }
    }]);

    return DatalistItem;
}(React.Component);

DatalistItem.propTypes = {
    /** Content to render in the list item */
    children: PropTypes.node.isRequired,

    /** CSS class for the list item */
    className: PropTypes.string,

    /** Set by a parent datalist component to indicate when the item is highlighted (but not necessarily selected) */
    isActive: PropTypes.bool,

    /** Set by a parent datalist component to receive the updated active item ID */
    setActiveItemID: PropTypes.func
};


export default DatalistItem;
import PropTypes from 'prop-types';